const delivery = (state = null, action) => {
  switch (action.type) {
    case "SET_DELIVERY":
      return action.payload;
    default:
      return state;
  }
};

export default delivery;
